/* L'agente Campagne in parole: la spia, la sua finestra e la pagina Campagne leggono lo
   stesso /campagne/agente e devono dire la STESSA cosa. Funzioni pure, provate a tavolino. */

export const COLORE_CAMPAGNE = '#0ea5e9';
export const COLORE_STANDBY = '#f59e0b';
export const COLORE_ERRORI = '#ef4444';

/* Uno solo dei cinque stati, dal piu' grave: fermo per errori e captcha vincono sull'attesa
   (sono attese anche loro, ma col motivo che conta dire). */
export function statoAgente(s) {
  if (!s || !s.attivo) return { chiave: 'spento', etichetta: 'spento', colore: COLORE_CAMPAGNE };
  if (s.fermo_per_errori) return { chiave: 'errori', etichetta: 'fermo per errori', colore: COLORE_ERRORI };
  if (s.standby) return { chiave: 'standby', etichetta: 'in attesa del captcha', colore: COLORE_STANDBY };
  if (s.in_attesa) return { chiave: 'attesa', etichetta: 'in attesa', colore: COLORE_CAMPAGNE };
  return { chiave: 'attivo', etichetta: 'attivo', colore: COLORE_CAMPAGNE };
}

export const titoloSpia = (s) => `AI Da qualificare — ${statoAgente(s).etichetta}`;

/* Per il dialog di gestione agenti, che conosce solo quattro parole. */
export function statoGestione(s) {
  const k = statoAgente(s).chiave;
  if (k === 'errori' || k === 'standby') return 'disservizio';
  if (k === 'attesa') return 'in attesa';
  return k;
}

/* Il motivo in chiaro, o '' se non c'e' niente da spiegare. */
export function motivoAgente(s) {
  const k = statoAgente(s).chiave;
  if (k === 'errori') {
    // Non e' detto che sia il database: qui finisce QUALUNQUE errore ripetuto (il 17/09/2026
    // era un dato non spedibile all'indagine, e «Il database non risponde» mandava a cercare
    // un guasto che non c'era). Il motivo vero e' in `ultimo_errore`.
    return 'Errori ripetuti nella lavorazione: l’agente si è fermato per qualche minuto e poi riprova da solo.'
      + (s.ultimo_errore ? ` Ultimo errore: ${s.ultimo_errore}` : '');
  }
  if (k === 'standby') {
    return 'Google chiede il captcha: l’agente aspetta un quarto d’ora e poi riprova. '
      + 'Le righe non sono state toccate.';
  }
  if (k === 'attesa') {
    if (s.bulk_attivo) return 'È in corso un lavoro avviato a mano: l’agente parte quando finisce.';
    return 'Nessuna riga accesa da indagare: appena ne accendi di nuove l’agente riparte.';
  }
  return '';
}

const nf = (n) => (n ?? 0).toLocaleString('it-IT');

export function fmtVelocita(v) {
  if (v == null) return '—';
  return `${nf(Math.round(v * 10) / 10)} righe/ora`;
}

/* Il tempo stimato: minuti, ore o giorni, arrotondati come li direbbe una persona. */
export function fmtEta(minuti) {
  if (minuti == null) return '—';
  if (minuti <= 0) return 'nessuna riga da fare';
  if (minuti < 60) return `circa ${minuti} min`;
  const ore = minuti / 60;
  if (ore < 24) {
    const h = Math.floor(ore);
    const m = Math.round(minuti - h * 60);
    return m ? `circa ${h} h ${m} min` : `circa ${h} h`;
  }
  const giorni = Math.round((ore / 24) * 10) / 10;
  return `circa ${nf(giorni)} ${giorni === 1 ? 'giorno' : 'giorni'}`;
}

export const fmtResaAgente = (r) => (r == null ? '—' : `${r}%`);
